var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-toggle": true,
          "show-delete": false,
          "show-save": false,
          "show-cancel": false,
        },
        on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
      }),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _c("contact-list-side-menu", {
              attrs: { filter: _vm.filter },
              on: { filter: _vm.filterList, reset: _vm.resetList },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "tile is-parent" }, [
            _c(
              "article",
              { staticClass: "tile is-child box" },
              [
                _c(
                  "bulma-table",
                  {
                    staticClass:
                      "table is-bordered is-striped is-narrow is-fullwidth",
                    attrs: {
                      columns: _vm.columns,
                      "page-index": _vm.filter.pageIndex,
                      "page-size": _vm.filter.pageSize,
                      "total-rows": _vm.totalRows,
                      "is-loading": _vm.isTableLoading,
                      "sort-column": _vm.filter.sortColumn,
                      "sort-order": _vm.filter.sortOrder,
                    },
                    on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                  },
                  _vm._l(_vm.entitySummaries, function (c, idx) {
                    return _c(
                      "tr",
                      {
                        key: c.id,
                        class: { "is-selected": _vm.selectedRow === idx },
                        on: {
                          click: function ($event) {
                            return _vm.highlightSelected(idx, $event)
                          },
                        },
                      },
                      [
                        _c("td", [_vm._v(_vm._s(c.title))]),
                        _c(
                          "td",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: { path: c.contactId },
                                  append: "",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(c.firstName) +
                                    ", " +
                                    _vm._s(c.lastName) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("td", [_vm._v(_vm._s(c.objectType))]),
                        _c("td", [_vm._v(_vm._s(c.parentName))]),
                        _c("td", [_vm._v(_vm._s(c.defaultPhone))]),
                        _c("td", { staticClass: "is-email" }, [
                          _c("div", [_vm._v(_vm._s(c.defaultEmail))]),
                        ]),
                        _c("td", { staticClass: "has-text-centered" }, [
                          _c(
                            "span",
                            {
                              staticClass: "icon",
                              class: [
                                c.active
                                  ? "has-text-success"
                                  : "has-text-danger",
                              ],
                            },
                            [
                              _c("i", {
                                staticClass: "mdi mdi-24px",
                                class: [c.active ? "mdi-check" : "mdi-close"],
                              }),
                            ]
                          ),
                        ]),
                        _c(
                          "td",
                          { staticClass: "has-text-centered" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass:
                                  "button is-primary is-small is-inverted",
                                attrs: {
                                  to: { path: c.contactId },
                                  append: "",
                                },
                              },
                              [
                                _c("span", { staticClass: "icon is-medium" }, [
                                  _c("i", {
                                    staticClass: "mdi mdi-lead-pencil mdi-24px",
                                  }),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }